var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-p-2.5 tw-font-semibold tw-text-primary-500",class:{ 'tw-opacity-75': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":(event) => _vm.$emit('click', event)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }